'use strict';

var capPhoneConfig = [];
var urlCapPhoneConfig = $("#url-cap-phone-config").val();
var urlCapPhone = $("#url-cap-phone").val();

$.ajax({
    url: urlCapPhoneConfig,
    type: 'get',
    async: false,
    dataType: 'json',
    success: function (data) {
        var capConfiguration = data.result;
        capPhoneConfig = capConfiguration.length > 0 ? JSON.parse(capConfiguration) : [];
    },
    error: function (err) { }
});

function getConfig(idForm) {
    if (capPhoneConfig.length > 0) {
        return capPhoneConfig.find(form => form.idForm === idForm)
    }
}

function getIdForms() {
    var ids = [];
    capPhoneConfig.forEach(obj => {
        ids.push(obj.idForm);
    });
    return ids;
}

function callProcessPhoneFlow(currentFormConfig) {
    var $phoneSelector = $("#" + currentFormConfig.idPhone);
    var $formSelector = $("form[id='" + currentFormConfig.idForm + "']");
    var $currentCountrySelector = $("#currentCountry");
    var currentCountry = $currentCountrySelector.length > 0 ? $currentCountrySelector.val() : 'FR';

    if ($formSelector.length === 0) {
        $formSelector = $("form[name='" + currentFormConfig.idForm + "']")
    }

    $.spinner().start();

    $.ajax({
        url: urlCapPhone,
        method: 'GET',
        data: {
            sTel: $phoneSelector.val(),
            sIsoPays: currentCountry,
            idForm: currentFormConfig.idForm
        },
        success: function (data) {

            if (data.sCodeRetour === 'XXXXXX') {
                $.spinner().stop();
                if (data.errorMessage) {
                    $phoneSelector.next('.invalid-feedback').empty().html(data.errorMessage).show();
                    $phoneSelector.addClass("is-invalid");
                    $formSelector.find(":submit").prop('disabled', true);
                    $(".submit-shipping, .submit-payment").prop('disabled', true);
                    $.spinner().stop();
                    return false;
                }
                return false;
            } else {
                if (data.errorMessage) {
                    $phoneSelector.next('.invalid-feedback').empty().html(data.errorMessage).show();
                    $phoneSelector.addClass("is-invalid");
                    $formSelector.find(":submit").prop('disabled', true);
                    $(".submit-shipping, .submit-payment").prop('disabled', true);
                    $.spinner().stop();
                    return false;
                }

                if (data.returnCode === '000110' || data.iReturnValue === 0) {
                    $phoneSelector.val(data.phoneFlow[0].sTel);
                    $phoneSelector.removeClass("is-invalid");
                    $phoneSelector.next('.invalid-feedback').empty().hide();
                    $formSelector.find(":submit").prop('disabled', false);
                    $(".submit-shipping, .submit-payment").prop('disabled', false);
                } else {
                    $phoneSelector.addClass("is-invalid");
                    $phoneSelector.next('.invalid-feedback').empty().html("Merci de saisir un numéro de téléphone valide").show();
                    $(".submit-shipping, .submit-payment").prop('disabled', true);
                    $formSelector.find(":submit").prop('disabled', true);
                }
            }
            $.spinner().stop();
        }

    });
}


module.exports = {
    getConfig: getConfig,
    getIdForms: getIdForms,
    callProcessPhoneFlow: callProcessPhoneFlow
}